import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { colors } from '../../const'
import { IRuneSupply } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getRuneBurnConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_runesupply', timeframe)) as IRuneSupply[]
	const series1 = chartData
		.filter((element: IRuneSupply) => new Date(element.DAY).getTime() >= new Date('2024-09-25').getTime())
		.map((element: IRuneSupply) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.ADR17 }
		})
	const series2 = chartData
		.filter((element: IRuneSupply) => new Date(element.DAY).getTime() >= new Date('2024-09-25').getTime())
		.map((element: IRuneSupply) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: -element.CUMULATIVE_ADR17_BURN }
		})
	const config: IChart[] = [
		{
			data: series2,
			strokeWidth: 2,
			name: 'Cumulative ᚱune Burn',
			type: 'line',
			seriesGroup: '[rune] ',
			color: 'white',
			unitSymbol: 'ᚱ'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'burn',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ',
			barGroup: 'rune'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const RuneBurn = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getRuneBurnConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="RUNE Burn"
			chartDesc="RUNE burned over time."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="2b7a875e-cce0-49c2-ad6c-87f2a7c6fc16"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
		/>
	)
}

export default RuneBurn
